<template>
  <div
    class="w-full h-[38px] rounded-md bg-ground-100 flex items-center relative"
    :class="customClass"
  >
    <!-- 背景指示器，通过transform控制位置 -->
    <div
      class="absolute h-full bg-ground-100 rounded transition-transform duration-200 ease-out"
      :style="{
        width: `${100 / options.length}%`,
        padding: `${activePadding}px`,
        transform: `translate3d(${100 * modelValue}%, 0, 0)`,
        backfaceVisibility: 'hidden',
        WebkitBackfaceVisibility: 'hidden',
      }"
    >
      <div class="w-full h-full bg-ground-0 rounded-md" />
    </div>

    <!-- 选项按钮 -->
    <div
      v-for="(option, index) in options"
      :key="index"
      @click.stop="handleSelect(index)"
      class="h-full flex-1 flex items-center justify-center text-ink-500 ink-14 font-medium cursor-pointer z-10 transition-colors duration-200"
      :class="{ 'text-ink-950': modelValue === index }"
    >
      <slot :name="`option-${index}`" :option="option">
        <div class="flex items-center justify-center">
          <span> {{ typeof option === 'string' ? i18nRender(option) : option.label }}</span>
          <span
            v-if="typeof option === 'object' && option.count"
            class="h-5 min-w-5 bg-ground-200 ink-12 text-blue-primary whitespace-nowrap rounded-sm ml-1 px-[6px]"
            >{{ option.count }}</span
          >
        </div>
      </slot>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { i18nRender } from '@/locales'

export interface TabOption {
  key: string
  label: string
  count: number | string
}

const props = withDefaults(
  defineProps<{
    options: (string | TabOption)[]
    modelValue: number
    customClass?: string
    activePadding?: number
  }>(),
  {
    activePadding: 2,
  },
)

const emit = defineEmits<{
  (e: 'update:modelValue', value: number): void
  (e: 'change', value: number, option: string | TabOption): void
}>()

const handleSelect = (index: number) => {
  if (index === props.modelValue) return
  emit('update:modelValue', index)
  emit('change', index, props.options[index])
}
</script>
